<script setup lang="ts">

import { computed } from "vue";
import { twMerge } from "tailwind-merge";

// Props
const props = defineProps({
  label: { type: String as PropType<string>, default: null },
  value: { type: Number as PropType<number>, default: 0 },
  total: { type: Number as PropType<number>, default: 100 },
  dataTestid: {
    type: String as PropType<string>,
    default: "molecule-rating-bar",
  },
  appendClass: { type: String as PropType<string>, default: null },
});

// Calculate width percentage
const widthPercentage = computed(() => {
  if (
    !Number.isFinite(props.value) ||
    !Number.isFinite(props.total) ||
    props.total <= 0
  )
    return "0%"; // Handle edge cases
  const percentage = (props.value / props.total) * 100;
  return `${Math.min(percentage, 100)}%`; // Ensure it doesn't exceed 100%
});
</script>

<template>
 <div
    :class="twMerge('flex justify-center items-center space-x-2', appendClass)"
    :data-testid="dataTestid"
  >
      <slot name="label">
      <div class="text-info dark:text-info-dark whitespace-nowrap w-8">
        {{ label }}
      </div>
    </slot>
    <div class="w-full h-4 bg-natural-light-grey rounded-xs overflow-hidden">
      <div
        class="bg-warning-dark rounded-xs h-4 select-none text-xs-mobile transition-all duration-300"
        :style="{ width: widthPercentage }"
      ></div>
    </div>
  </div>
</template>
